/** модальное окно для выбора категорий в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { onEnter, setOnChange } from "components/special";
import { FloatModal } from "components/special";

const { api } = adminAPI.actions;

const FloatCurrenciesModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Payments.Currencies" />}
      {...props}
      head={(searchCurrencies, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th>
              <IntlMessages id="symbol" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(currency, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!currency.enabled ? "text-strike" : ""}>
            {currency.name}
          </td>
          <td>{currency.symbol}</td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatCurrencies = (props) => {
  return <FloatCurrenciesModal {...props} />;
};

export default connect(null, {
  getData: api.get("/api/payments/currencies"),
})(FloatCurrencies);
